import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-add-tier',
  templateUrl: './add-tier.component.html',
  styleUrl: './add-tier.component.scss',
})
export class AddTierComponent {
  tierName: string = '';
  public maxLength = 25;
  public charactersCount = 0;
  public counter = `${this.charactersCount}/${this.maxLength}`;

  @Output()
  onConfirm: EventEmitter<string | null> = new EventEmitter<string | null>();

  onCancel() {
    this.onConfirm.emit(null);
  }

  onAccept() {
    this.onConfirm.emit(this.tierName);
  }
}
